import { render, staticRenderFns } from "./SiteLogoV6.vue?vue&type=template&id=22128054&"
import script from "./SiteLogoV6.vue?vue&type=script&lang=js&"
export * from "./SiteLogoV6.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VChip,VImg})
